/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import ReactDOM from 'react-dom';
import { Routes } from 'react-router';

import { ErrorBoundary, SkipNavContent } from 'sarsaparilla';

import { Footer } from 'site-kit';
import { ExternalPageFrame } from 'shared-ui/external-app-base';
import ErrorPage from 'shared-ui/components/ErrorPage/ErrorPage';
import { TopNavigationExternal } from 'shared-ui/TopNavigationExternal';

import makeSwitchRoutes from './makeSwitchRoutes';

export default function App() {
    return (
        <ExternalPageFrame>
            <TopNavigationExternal isGuestAllowed={true} />

            <ErrorBoundary fallbackElement={<ErrorPage />}>
                <SkipNavContent role="main" className="rec-page">
                    <Routes>{makeSwitchRoutes()}</Routes>
                </SkipNavContent>
            </ErrorBoundary>

            <Footer />
        </ExternalPageFrame>
    );
}
